function ContrastIcon()
{   
    return(
        <svg className="contrastSvg" fill="white" width="70%" height="70%" viewBox="0 0 512 512"><circle cx="256" cy="256" r="208" style={{"fill":"none","stroke":"#ffffffff","strokeLinejoin":"round","strokeWidth":"32px"}}/><path className="contrastSvg" d="M256,464C141.12,464,48,370.88,48,256S141.12,48,256,48Z"/></svg>
    )
}   

export default ContrastIcon